<template>

  <Cascader ref="areaList" v-model="value" :data="areaList" @on-change="changeData" />
</template>
<script>
export default {
  data () {
    return {
      value: [],
      areaList: [],
      province: '',
      city: ''
    }
  },
  created() {
    this.getAllProvince()
  },
  methods: {
    getAllProvince() {
      const url = '/intelligence-service/region'
      this.$get(url).then(res => {
        if (res.code === 0) {
          res.data.map(item => {
            item.value = item.provinceName
            item.label = item.provinceName
            item.children = [...item.cityNames]

            for (var i = 0; i < item.children.length; i++) {
              if (item.children.length >= i) {
                item.children[i] = { value: item.children[i], label: item.children[i] }
              }
            }
          })
          this.areaList = res.data
          console.log(this.areaList)
        }
      })
    },
    changeData(value, selectedData) {
      console.log(value, 'selectedData', selectedData)
      this.$emit('cityChange', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/city/city.vue